/**
 * 利用者のフォーマット用ユーティリティ関数
 */

/**
 * 利用者の表示名を取得する
 * @param displayName カスタム表示名
 * @param patientName 正式な利用者名
 * @returns 表示名（カスタム表示名があればそれを使用、なければ正式名 + "さま"）
 */
export const getPatientName = (displayName?: string, patientName?: string): string => {
  return displayName || (patientName ? `${patientName} さま` : '-');
};